module.exports = __webpack_public_path__ + "img/btn_shiyong@2x.0feaeeaf.png";